export interface BarGraphConfig {
  type: GraphTypes;
  showLegends?: boolean;
  tickFormat?: string;
  formatType?: string;
  tickPadding?: number;
  legendsPerRow?: number;
  colorScheme?: string[];
}
export interface DefaultBarGraphConfig {
  tickPadding: number;
  legendPadding: number;
  yAxisPadding: number;
  labelLeftMargin: number;
  labelTopMargin: number;
  margin: GraphMargin;
}

export interface GraphMargin {
  top: number;
  right: number;
  bottom: number;
  left: number;
}

export interface GraphLegendConfig {
  legendCircleRadius: number;
  legendCircleDiameter: number;
  legendsPerRow: number;
  legendWidth: number;
  legendHeight: number;
  legendLabelLeftMargin: number;
}

export interface MobileGraphData {
  name?: string;
  values: BarGraphData[];
}

export const defaultGraphConfig: DefaultBarGraphConfig & GraphLegendConfig = {
  tickPadding: 10,
  legendPadding: 50,
  yAxisPadding: 0.5,
  legendCircleRadius: 6,
  legendCircleDiameter: 12,
  legendsPerRow: 1,
  legendWidth: 170,
  legendHeight: 30,
  legendLabelLeftMargin: 14,
  labelLeftMargin: 5,
  labelTopMargin: 10,
  margin: { top: 20, right: 60, bottom: 60, left: 120 },
};
export type HorizontalBarGraphConfig = BarGraphConfig &
  DefaultBarGraphConfig &
  GraphLegendConfig;

export interface BarGraphData {
  group?: string;
  category: string;
  value: number;
  percentage?: number;
  color?: string;
}

export enum GraphTypes {
  standard = 'standard',
  grouped = 'grouped',
}

export interface DefaultGroupGraphConfig {
  tickPadding: number;
  legendPadding: number;
  yGroupPadding: number;
  ySubGroupPadding: number;
  labelLeftMargin: number;
  labelTopMargin: number;
  groupLabelTop: number;
  margin: GraphMargin;
}
export const defaultGroupGraphConfig: DefaultGroupGraphConfig &
  GraphLegendConfig = {
  tickPadding: 10,
  legendPadding: 50,
  yGroupPadding: 0.4,
  ySubGroupPadding: 0.3,
  legendCircleRadius: 6,
  legendCircleDiameter: 12,
  legendsPerRow: 1,
  legendWidth: 170,
  legendHeight: 30,
  legendLabelLeftMargin: 14,
  labelLeftMargin: 5,
  labelTopMargin: 10,
  groupLabelTop: 20,
  margin: { top: 20, right: 50, bottom: 60, left: 120 },
};

export type HorizontalGroupBarGraphConfig = BarGraphConfig &
  DefaultGroupGraphConfig &
  GraphLegendConfig;
